import { createFileRoute, Outlet } from '@tanstack/react-router'
import { AdminGuard } from '@/components/layout/admin-guard'

export const Route = createFileRoute('/_authenticated/administrator')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <AdminGuard>
      <Outlet />
    </AdminGuard>
  )
}
